import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import { HelmetProvider } from "react-helmet-async";
// import { Helmet } from "react-helmet-async";
import SEO from "./Components/SEO";

import reportWebVitals from "./reportWebVitals";

import Header from "./Components/Header/Header";
import Main from "./Components/Main-p/Main";
import About from "./Components/About/About";
import Work from "./Components/Work/Work";
import Before from "./Components/Before/Before";
import Feedback from "./Components/Feedback/Feedback";
import Order from "./Components/Order/Order";
import Footer from "./Components/Footer/Footer";
import Price from "./Components/Price/Price";

import Popup from "./Components/ui/Popup/Popup";

// import img_popup from "./Components/Photo/popup.jpg";
import fb from "./Components/Photo/23fb.jpg";

const Popups = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    setIsPopupOpen(true); // Открываем попап при загрузке страницы
    document.body.style.overflow = "hidden";
  }, []);

  const handleClose = () => {
    setIsPopupOpen(false); // Закрываем попап
    document.body.style.overflow = "auto";
  };

  return (
    <div>
      {isPopupOpen && (
        <Popup
          className="popup"
          handleClose={handleClose}
          image={fb}
          title="С Днём защитника Отечества! 🎖️"
          description={
            <>
              <span
                style={{
                  background:
                    "linear-gradient(45deg, #4B5320, #6B8E23, #A67B5B, #C0A080)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  textDecoration: "none",
                  fontWeight: "bold",
                }}
              >
                23 февраля
              </span>{" "}
              — день силы, мужества и отваги! Это прекрасный повод сказать
              тёплые слова благодарности тем, кто оберегает и защищает. Только
              до <span
                style={{
                  background:
                    "linear-gradient(45deg, #4B5320, #6B8E23, #A67B5B, #C0A080)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  textDecoration: "none",
                  fontWeight: "bold",
                }}
              >
                21 февраля
              </span>{" "}на сайте доступны уникальные десерты, созданные
              специально к этому празднику. Порадуйте близких особенным вкусом и
              атмосферой! 💙
            </>
          }
        />
      )}
    </div>
  );
};

const App = () => {
  const [dataProduct, setDataProduct] = useState(null);

  return (
    <React.StrictMode>
      <HelmetProvider>
        <SEO
          title="Интернет-магазин кондитерской продукции на каждый праздник!"
          description="На моем сайте вы можете найти широкий выбор кондитерской продукции от больших тортов до маленьких капкейков на любой случай в жизни!"
          name="Даша торты на заказ в Чехове"
          type="website"
        />
        <Header />
        <Main />
        <About />
        <Work />
        <Price setProduct={setDataProduct} />
        <Before />
        <Feedback />
        <Order data={dataProduct} />
        <Footer />
        {/* <Popups /> */}
      </HelmetProvider>
    </React.StrictMode>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
